import {
  ROUTE_PATH,
  ROUTE_PATHS_WITHOUT_SUB_NAV_BAR
} from 'modules/routes/constants/index.cjs'

/**
 * Checks whether the current matchPath should have the <SubNavBar>.
 * @param  {string}  matchPath
 * @returns {boolean}
 */
function hasSubNavBarRouteUtil (matchPath) {
  return !ROUTE_PATHS_WITHOUT_SUB_NAV_BAR.some(pathWithoutSubNavBar => {
    if (pathWithoutSubNavBar === ROUTE_PATH.HOME) {
      return matchPath === pathWithoutSubNavBar
    }

    return matchPath === pathWithoutSubNavBar
  })
}

export default hasSubNavBarRouteUtil
